/** Hermes 平台模板 IDE 会话：context / 复用键（见 Plan D3）。 */

export type PlatformTemplateIdeKbBinding = {
  wiki_id: number;
  access: "read" | "write";
};

export type PlatformTemplateIdeContext = {
  mode: "platform_template_ide";
  accountId: string;
  brandId: number;
  brandSiteId: number;
  kbBindings: PlatformTemplateIdeKbBinding[];
};

export function platformTemplateIdeChatContext(ctx: PlatformTemplateIdeContext) {
  return {
    mode: "platform_template_ide" as const,
    brand_id: ctx.brandId,
    brand_site_id: ctx.brandSiteId,
    kb_bindings: ctx.kbBindings,
  };
}

export function clearPlatformTemplateIdeModeContext() {
  return { mode: null as null };
}

/** 企业 + 品牌 Wiki 绑定；默认只读，writeAccess 时两库一并升级为 write。 */
export function platformTemplateIdeKbBindings(opts: {
  enterpriseWikiId?: number | null;
  brandWikiId?: number | null;
  writeAccess?: boolean;
}): PlatformTemplateIdeKbBinding[] {
  const access = opts.writeAccess ? "write" : "read";
  const bindings: PlatformTemplateIdeKbBinding[] = [];
  const enterpriseId = Number(opts.enterpriseWikiId);
  if (Number.isFinite(enterpriseId) && enterpriseId > 0) {
    bindings.push({ wiki_id: enterpriseId, access });
  }
  const brandId = Number(opts.brandWikiId);
  if (Number.isFinite(brandId) && brandId > 0) {
    bindings.push({ wiki_id: brandId, access });
  }
  return bindings;
}

export function matchesPlatformTemplateIdeChat(
  chat: { context?: Record<string, unknown> | null },
  ctx: Pick<PlatformTemplateIdeContext, "brandId" | "brandSiteId">,
): boolean {
  const context = chat.context;
  if (!context || typeof context !== "object") return false;
  if (context.mode !== "platform_template_ide") return false;
  if (Number(context.brand_id) !== ctx.brandId) return false;
  return Number(context.brand_site_id) === ctx.brandSiteId;
}

export function isPlatformTemplateIdeChat(chat: {
  context?: Record<string, unknown> | null;
}): boolean {
  return chat.context?.mode === "platform_template_ide";
}

function parseKbBindings(raw: unknown): PlatformTemplateIdeKbBinding[] {
  if (!Array.isArray(raw)) return [];
  const out: PlatformTemplateIdeKbBinding[] = [];
  for (const item of raw) {
    if (!item || typeof item !== "object") continue;
    const row = item as Record<string, unknown>;
    const wikiId = Number(row.wiki_id);
    if (!Number.isFinite(wikiId) || wikiId <= 0) continue;
    const access = row.access === "write" ? "write" : "read";
    out.push({ wiki_id: wikiId, access });
  }
  return out;
}

export function platformTemplateIdeFromChat(
  chat: { context?: Record<string, unknown> | null },
  accountId: string,
): PlatformTemplateIdeContext | null {
  const context = chat.context;
  if (!context || typeof context !== "object") return null;
  if (context.mode !== "platform_template_ide") return null;
  const brandId = Number(context.brand_id);
  const brandSiteId = Number(context.brand_site_id);
  if (!Number.isFinite(brandId) || brandId <= 0) return null;
  if (!Number.isFinite(brandSiteId) || brandSiteId <= 0) return null;
  return {
    mode: "platform_template_ide",
    accountId,
    brandId,
    brandSiteId,
    kbBindings: parseKbBindings(context.kb_bindings),
  };
}

/** 当前是否在平台模板 IDE 路由。 */
export function isPlatformTemplateIdeRoute(pathname: string): boolean {
  if (!pathname) return false;
  return /^\/platform\/templates\/[^/]+\/ide\/?$/.test(pathname);
}

export function platformTemplateIdeCapabilityChipLabel(): string {
  return "模板 IDE";
}
